export default "__VITE_PUBLIC_ASSET__6b37a0dd__"